import Vue from 'vue';
import Vuex from 'vuex';
import {
    getOptions,
    fetchItems,
    fetchItemsWithOption,
    moreItems,
    moreItemsWithOption,
    getItem,
    submitRcmd,
    reportOption,
} from '../api';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        firstPath: '',
        title: '포토리뷰',
        options: {},
        lastFlag: false,
        lastMessageId: 0,
        loginYn: 'N',
    },
    mutations: {
        SET_TITLE(state, title) {
            state.title = title;
        },
        SET_FIRSTPATH(state, firstPath) {
            var pathString = state.firstPath;
            if (pathString == '' || pathString == '/') {
                state.firstPath = firstPath;
            }
        },
        SET_OPTIONS(state, data) {
            state.options = data;
        },
        SET_ITEM(state, data) {
            state.appYn = data.appYn;
            state.prdcd = data.prdcd;
            state.detail = data;
        },
        SET_ITEMS(state, data) {
            state.appYn = data.appYn;
            state.prdcd = data.prdcd;
            state.totalCnt = data.totalCnt;
            state.loginYn = data.loginYn;
            state.items = data.items;
            if (data.items.length) {
                state.lastMessageId =
                    data.items[data.items.length - 1].messageId;
            }
        },
        SET_MORE_ITEMS(state, data) {
            if (data.length) {
                // state.items = state.items.concat(data);
                data.forEach((item) => {
                    state.items.push(item);
                });
                state.lastMessageId = data[data.length - 1].messageId;
            } else {
                state.lastFlag = true;
            }
        },
        SET_RCMD_CNT(state, data) {
            if (state.items) {
                if ('I' == data.kind) {
                    state.items[data.idx].rcmdCnt++;
                    state.items[data.idx].rcmdFlg = 'Y';
                } else if ('D' == data.kind) {
                    state.items[data.idx].rcmdCnt--;
                    state.items[data.idx].rcmdFlg = 'N';
                } else if ('E' == data.kind) {
                    console.log('오류가 발생하였습니다, 다시 시도해주세요');
                }
            } else if (state.detail) {
                if ('I' == data.kind) {
                    state.detail.rcmdCnt++;
                    state.detail.rcmdFlg = 'Y';
                } else if ('D' == data.kind) {
                    state.detail.rcmdCnt--;
                    state.detail.rcmdFlg = 'N';
                }
            }
        },
        SET_REPORT_OPTION(state, data) {
            state.reportOption = data;
        },
        SYNC_RCMD_ITEM(state, data) {
            var idx = data.idx;

            if (state.items) {
                while (
                    state.items.length > idx + 1 &&
                    state.items[idx].messageId == state.items[idx + 1].messageId
                ) {
                    state.items[idx + 1].rcmdCnt = state.items[idx].rcmdCnt;
                    state.items[idx + 1].rcmdFlg = state.items[idx].rcmdFlg;
                    idx++;
                }

                idx = data.idx;

                while (
                    idx - 1 != -1 &&
                    state.items[idx].messageId == state.items[idx - 1].messageId
                ) {
                    state.items[idx - 1].rcmdCnt = state.items[idx].rcmdCnt;
                    state.items[idx - 1].rcmdFlg = state.items[idx].rcmdFlg;
                    idx--;
                }
            }
        },
    },
    actions: {
        async GET_OPTIONS({ commit }, prdcd) {
            const response = await getOptions(prdcd);
            commit('SET_OPTIONS', response);
            return response;
        },
        async FETCH_ITEMS({ commit }, prdcd) {
            const response = await fetchItems(prdcd);
            commit('SET_ITEMS', response);
            return response;
        },
        async FETCH_ITEMS_WITH_OPTION({ commit }, params) {
            const response = await fetchItemsWithOption(
                params.prdcd,
                params.optNm
            );
            commit('SET_ITEMS', response);
            return response;
        },
        async MORE_ITEMS({ state, commit }) {
            if (state.lastFlag) {
                return;
            }
            const response = await moreItems(state.prdcd, state.lastMessageId);
            commit('SET_MORE_ITEMS', response);
            return response;
        },
        async MORE_ITEMS_WITH_OPTION({ state, commit }, optNm) {
            if (state.lastFlag) {
                return;
            }
            const response = await moreItemsWithOption(
                state.prdcd,
                state.lastMessageId,
                optNm
            );
            commit('SET_MORE_ITEMS', response);
            return response;
        },
        async GET_ITEM({ commit }, params) {
            const response = await getItem(params.prdcd, params.messageId);
            commit('SET_ITEM', response);
            return response;
        },
        async SUBMIT_RCMD({ state, commit }, params) {
            const response = await submitRcmd(
                params.prdcd,
                params.messageId,
                params.myRevwFlg,
                params.rcmdFlg,
                params.oppstFlg
            );

            const idx = params.index;
            const data = { idx: params.index, kind: response };

            await commit('SET_RCMD_CNT', data);
            commit('SYNC_RCMD_ITEM', data);
            return response;
        },
        async GET_REPORT_OPTION({ commit }) {
            const response = await reportOption();
            commit('SET_REPORT_OPTION', response);
            return response;
        },
    },
    modules: {},
});
